
        import Symbol from "../../../svg-baker-runtime/browser-symbol.js";
        import sprite from "../../../svg-sprite-loader/runtime/browser-sprite.build.js";

        const symbol = new Symbol({
  "id": "icon-material-panorama_photosphere",
  "use": "icon-material-panorama_photosphere-usage",
  "viewBox": "0 -960 960 960",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 -960 960 960\" id=\"icon-material-panorama_photosphere\"><path d=\"M479.76-74.5q-119.33 0-214.59-62.9T121.2-301.3q-10.77-4.77-21.2-9.36-10.43-4.6-20.15-9.84-21.2-11.48-33.27-31.27Q34.5-371.57 34.5-396v-168q0-24.43 12.08-44.23 12.07-19.79 33.27-31.27 9.72-5.24 20.15-9.84 10.43-4.59 21.2-9.36 48.71-101 143.97-163.9t214.59-62.9 214.59 62.9 144.22 163.9q10.52 4.77 21.07 9.36 10.56 4.6 20.27 9.84 21.68 11.72 33.63 31.77Q925.5-587.67 925.5-564v168q0 23.67-11.96 43.73-11.95 20.05-33.63 31.77-9.71 5.24-20.27 9.84-10.55 4.59-21.07 9.36-48.96 101-144.22 163.9T479.76-74.5m1.24-62.87q77.09 0 147.41-36.56 70.33-36.57 117.37-101.9-61.32 18.29-131.77 29.05-70.44 10.76-133.01 10.76-63.33 0-134.77-10.76-71.45-10.76-133.01-29.05 51.04 66.33 122.37 102.4 71.32 36.06 145.41 36.06m0-686.26q-74.09 0-145.41 36.06-71.33 36.07-122.37 102.4 61.56-18.29 133.01-29.17 71.44-10.88 134.77-10.88 62.57 0 133.01 10.88 70.45 10.88 131.77 29.17-47.04-65.33-117.37-101.9-70.32-36.56-147.41-36.56m0 519.48q110.8 0 208.33-23.38 97.52-23.38 168.04-60.9v-184.14q-70.52-37.52-168.04-60.4Q591.8-655.85 481-655.85q-111.8 0-209.33 22.88-97.52 22.88-169.04 60.4v184.14q71.52 37.52 169.04 60.9Q369.2-304.15 481-304.15\" /></symbol>"
});
        sprite.add(symbol);

        function Icon({...props}) {
            return (
                <svg {...props} className="icon" fill="currentColor">
                    <use xlinkHref="#icon-material-panorama_photosphere"/>
                </svg>
            );
        };

        Icon.id = "icon-material-panorama_photosphere";

        export default Icon;
    